module.exports = require('../lib/createWebStoragePersister/index');